import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";


export const IG_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ig.IgPassTokenUsed', {route: '/ig/igPassTokenUseds'}],
            ['ig.IgAccessToken', {route: '/ig/igAccessTokens'}],
            ['ig.IgAccessTokenUsed', {route: '/ig/igAccessTokenUseds'}],
            ['ig.IgPassToken', {route: '/ig/igPassTokens'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
